import React from 'react'
import PropTypes from 'prop-types'
import { connect } from 'react-redux'
import { updateSearchTerm } from 'store/searchTerm'
import 'styles/d3/searchinput.scss'

class SearchInput extends React.Component {
  constructor(props) {
    super(props)
    this.state = { isFocused: false }
  }

  componentDidMount() {
    this.props.updateSearchTerm('')
  }

  handleClear = () => {
    this.props.updateSearchTerm('')
  }

  render() {
    return (
      <div className='search-input'>
        <input
          ref='input'
          value={this.props.searchTerm}
          onChange={e => this.props.updateSearchTerm(e.target.value)}
          className={this.props.searchTerm ? '' : 'empty'}
          onBlur={() => this.setState({ isFocused: false })}
          onFocus={() => this.setState({ isFocused: true })}
        />
        {this.props.searchTerm ? (
          <i onClick={this.handleClear} className='fa fa-times' />
        ) : (
          <i onClick={() => this.refs.input.focus()} className='fa fa-search' />
        )}
      </div>
    )
  }
}

const mapProps = ({ searchTerm }) => ({ searchTerm })

SearchInput.propTypes = {
  searchTerm: PropTypes.string,
  updateSearchTerm: PropTypes.func,
}

export default connect(
  mapProps,
  { updateSearchTerm },
)(SearchInput)



// WEBPACK FOOTER //
// ./src/components/SearchInput.js